import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js"
import PropTypes from "prop-types"
import React from "react"

const StripeConnectOnboarding = ({ onSuccess, stripeConnectInstance }) => {
  const handleOnboardingExit = () => {
    if (onSuccess) {
      onSuccess()
    }
  }

  if (!stripeConnectInstance) {
    return null
  }

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectAccountOnboarding onExit={handleOnboardingExit} />
    </ConnectComponentsProvider>
  )
}

StripeConnectOnboarding.propTypes = {
  onSuccess: PropTypes.func,
  stripeConnectInstance: PropTypes.object,
}

export default StripeConnectOnboarding
